

function AplikSoftverVEI(){
 

    return(
        <div>

            
            AplikSoftverVEI
        </div>
    );
};

export default AplikSoftverVEI;